import { Provider } from '@angular/core';
import { AI_TOOL_PROVIDERS } from '../tool-registry.service';
import { AI_DATA_SOURCES } from '@omni/ai/summary/data-source-registry.service';
import { RecordDataSourcesService } from '@omni/ai/summary/record-data-sources.service';
import { NavigationTools } from './navigation.tools';
import { SearchTools } from './search.tools';
import { DataSummaryTools } from './data-summary.tools';
import { ActivityTools } from './activity.tools';
import { CallPlanTools } from './call-plan.tools';
import { ContentTools } from './content.tools';
import { RxTools } from './rx.tools';
import { ScreenTools } from './screen.tools';
import { MeetingTools } from './meeting.tools';
import { GeolocationService } from '@omni/services/location/gelolocation';

export { NavigationTools } from './navigation.tools';
export { SearchTools } from './search.tools';
export { DataSummaryTools } from './data-summary.tools';
export { ActivityTools } from './activity.tools';
export { CallPlanTools } from './call-plan.tools';
export { ContentTools } from './content.tools';
export { RxTools } from './rx.tools';
export { ScreenTools } from './screen.tools';
export { MeetingTools } from './meeting.tools';

/**
 * One-stop provider spread for the AI tool registry. Each tool-provider class
 * is registered twice: once as itself (so DI can construct it) and once under
 * the `AI_TOOL_PROVIDERS` multi-token via `useExisting` (so the registry sees
 * the same instance).
 */
export const AI_TOOL_REGISTRY_PROVIDERS: Provider[] = [
  NavigationTools,
  SearchTools,
  DataSummaryTools,
  ActivityTools,
  CallPlanTools,
  ContentTools,
  RxTools,
  ScreenTools,
  MeetingTools,
  GeolocationService,
  { provide: AI_TOOL_PROVIDERS, useExisting: NavigationTools, multi: true },
  { provide: AI_TOOL_PROVIDERS, useExisting: SearchTools, multi: true },
  { provide: AI_TOOL_PROVIDERS, useExisting: DataSummaryTools, multi: true },
  { provide: AI_TOOL_PROVIDERS, useExisting: ActivityTools, multi: true },
  { provide: AI_TOOL_PROVIDERS, useExisting: CallPlanTools, multi: true },
  { provide: AI_TOOL_PROVIDERS, useExisting: ContentTools, multi: true },
  { provide: AI_TOOL_PROVIDERS, useExisting: RxTools, multi: true },
  { provide: AI_TOOL_PROVIDERS, useExisting: ScreenTools, multi: true },
  { provide: AI_TOOL_PROVIDERS, useExisting: MeetingTools, multi: true },
  { provide: AI_TOOL_PROVIDERS, useExisting: GeolocationService, multi: true },
  { provide: AI_DATA_SOURCES, useExisting: RecordDataSourcesService, multi: true },
];
